import MyProperties from './MyProperties';

export default MyProperties;
